module.exports = __webpack_public_path__ + "img/2.ff7dcf8e.jpg";